const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'HeroSlider: Required elements not found',
	INIT_FAILED: 'HeroSlider: Initialization failed'
};

const CONFIG = {
	ANIMATION: {
		DURATION: 5000,
		TRANSITION: 'transform 0.5s ease-in-out'
	},
	CLASSES: {
		CONTAINER: 'simple-hero__slider',
		SLIDE: 'slide',
		INDICATOR: 'indicator',
		ACTIVE: 'active'
	},
	SELECTORS: {
		SLIDER: '#slider',
		INDICATORS: '#indicators'
	}
};

/**
 * Initialize hero slider functionality
 * @returns {void}
 */
const initializeHeroSlider = () => {
	try {
		const sliderContainer = document.querySelector(`.${CONFIG.CLASSES.CONTAINER}`);
		if (!sliderContainer) {
			console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
			return;
		}

		const slider = sliderContainer.querySelector(CONFIG.SELECTORS.SLIDER);
		const indicatorsContainer = sliderContainer.querySelector(CONFIG.SELECTORS.INDICATORS);
		const slides = sliderContainer.querySelectorAll(`.${CONFIG.CLASSES.SLIDE}`);

		if (!slider || !indicatorsContainer || !slides.length) {
			console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
			return;
		}

		let currentIndex = 0;

		/**
		 * Update slider indicators
		 * @returns {void}
		 */
		const updateIndicators = () => {
			indicatorsContainer.innerHTML = '';
			slides.forEach((slide, index) => {
				const indicator = document.createElement('div');
				indicator.classList.add(CONFIG.CLASSES.INDICATOR);
				
				if (index === currentIndex) {
					indicator.classList.add(CONFIG.CLASSES.ACTIVE);
				}
				
				indicator.addEventListener('click', () => {
					goToSlide(index);
				});
				
				indicatorsContainer.appendChild(indicator);
			});
		};

		/**
		 * Go to specific slide
		 * @param {number} index - Index of the slide to show
		 * @returns {void}
		 */
		const goToSlide = (index) => {
			currentIndex = index;
			const offset = -currentIndex * 100;
			slider.style.transition = CONFIG.ANIMATION.TRANSITION;
			slider.style.transform = `translateX(${offset}%)`;
			updateIndicators();
		};

		/**
		 * Go to next slide
		 * @returns {void}
		 */
		const nextSlide = () => {
			currentIndex = (currentIndex + 1) % slides.length;
			goToSlide(currentIndex);
		};

		// Initialize slider
		updateIndicators();
		
		// Start auto-sliding
		setInterval(nextSlide, CONFIG.ANIMATION.DURATION);
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeHeroSlider };
